import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NeoParametrizacionLineaDTO } from '../../Model/neoParametrizacionLineaDTO';
import { NeoPeriodicidadLineaDTO } from '../../Model/neoPeriodicidadLineaDTO';
import { NeoTasaLineaDTO } from '../../Model/neoTasaLineaDTO';
import { NeoTipoPeriodicidadDTO } from '../../Model/neoTipoPeriodicidadDTO';
import { ParametrizacionLineaService } from '../../Service/parametrizacion-linea.service';
import { PeriodicidadLineaService } from '../../Service/periodicidad-linea.service';
import { TasaLineaService } from '../../Service/tasa-linea.service';
import { TipoPeriodicidadService } from '../../Service/tipo-periodicidad.service';
import { AlertService } from '../../../services/alert.service';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';

const PATRON_NOMBRE_LINEA =
  '^[0-9a-zA-ZÀ-ÿ\u00f1\u00d1_]+(\\s+[0-9a-zA-ZÀ-ÿ\u00f1\u00d1_]+)*$';
const PATRON_VALOR_TASA = '^[0-9]{1,2}(.[0-9]{1,2})?$';
const TASA_MINIMA = 0.01;
const TASA_MAXIMA = 99.99;
const LONGITUD_MAXIMA_NOMBRE_LINEA = 100;
const CANTIDAD_MAXIMA_PLAZO_MESES = 120;
const CANTIDAD_MAXIMA_PERIODO_MESES = 12;
declare var $: any;
@Component({
    selector: 'app-crear-lineas-credito',
    templateUrl: './crear-lineas-credito.component.html',
    styleUrls: ['./crear-lineas-credito.component.scss'],
    standalone: false
})
export class CrearLineasCreditoComponent implements OnInit {
  // IdNeoliente
  idNeoCliente: any;
  // IdLineaCredito
  idLineaCredito: any;
  // Declaracion de formulario
  datosLineaIntermediarioForm: UntypedFormGroup;
  // Declaracion objeto neoParametrizacionLinea (edit)
  neoParametrizacionEdit: NeoParametrizacionLineaDTO =
    new NeoParametrizacionLineaDTO(
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null
    );
  // Declaracion array neoTasaLinea (edit)
  neoTasasLineaEdit: NeoTasaLineaDTO[] = [];
  // Declaracion array neoPeriodicidadLinea (edit)
  neoPeriodicidadLineaEdit: NeoPeriodicidadLineaDTO[] = [];
  // Array plazo meses
  mesesPlazo = [];
  // Array periodo meses
  mesesPeriodo = [];
  // Array periodicidad
  tiposPeriodicidad: NeoTipoPeriodicidadDTO[] = [];
  // Array tasas
  tasasDePago: number[] = [];
  // Validacion creado
  isCreado: boolean = false;
  // Loading
  isLoading: boolean = false;
  editar: boolean = false;
  listLineasAliado = [];
  constructor(
    protected tipoPeriodicidadService: TipoPeriodicidadService,
    protected parametrizacionLineaService: ParametrizacionLineaService,
    protected periodicidadLineaService: PeriodicidadLineaService,
    protected tasaLineaService: TasaLineaService,
    protected userIntermediarioService: UserService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private _sweetAlert:SweetAlertService
  ) {}
  ngOnInit(): void {
    this.mesesPlazo = this.crearArrayConNumerosHasta(
      CANTIDAD_MAXIMA_PLAZO_MESES
    );
    this.mesesPeriodo = this.crearArrayConNumerosHasta(
      CANTIDAD_MAXIMA_PERIODO_MESES
    );
    this.idLineaCredito = this.activatedRoute.snapshot.paramMap.get('idLinea');
    this.getIdNeoCliente();
    this.crearFormularioLineaIntermediario();
    this.getTiposPeriodicidad();
    this.cargarDatosParaEditar();
    this.getlineasAliado();
  }

  getlineasAliado(){
    this.parametrizacionLineaService.getLineasAliado('HABILITADO').subscribe((resp: any) =>{
      this.listLineasAliado = resp;
    });
  }

  getIdNeoCliente(): any {
    this.idNeoCliente = this.userIntermediarioService.getUser().idCliente;
  }
  getTiposPeriodicidad() {
    this.tipoPeriodicidadService.getTiposPeriodicidad().subscribe(
      (data) => {
        this.tiposPeriodicidad = data;
      },
      (err) => {
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );
  }

  crearFormularioLineaIntermediario() {
    this.datosLineaIntermediarioForm = this.formBuilder.group({
      idNombreLineasCredito: ['', Validators.required],
      nombreLinea: [
        '',
        [
          Validators.required,
          Validators.maxLength(LONGITUD_MAXIMA_NOMBRE_LINEA),
          Validators.pattern(PATRON_NOMBRE_LINEA),
        ],
      ],
      estadoLinea: ['', [Validators.required]],
      plazoInicial: ['', [Validators.required]],
      plazoFinal: ['', [Validators.required]],
      valorTasa: [
        '',
        [
          Validators.min(TASA_MINIMA),
          Validators.max(TASA_MAXIMA),
          Validators.pattern(PATRON_VALOR_TASA),
        ],
      ],
      periodicidadPagos: ['', [Validators.required]],
      periodoInicial: [''],
      periodoFinal: [''],
    });
  }
  isValidFieldDatosLineaIntermediarioForm(field: string) {
    return (
      (this.datosLineaIntermediarioForm.get(field)?.dirty ||
        this.datosLineaIntermediarioForm.get(field)?.touched) &&
      this.datosLineaIntermediarioForm.get(field)?.invalid
    );
  }
  validarTasa() {
    if (this.tasasDePago.length > 0) {
      if (this.datosLineaIntermediarioForm.get('valorTasa').value != null) {
        this.setearValidadoresLineaInterediarioForm('valorTasa', [
          Validators.min(TASA_MINIMA),
          Validators.max(TASA_MAXIMA),
          Validators.pattern(PATRON_VALOR_TASA),
        ]);
      } else {
        this.setearValidadoresLineaInterediarioForm('valorTasa', null);
      }
    } else {
      this.setearValidadoresLineaInterediarioForm('valorTasa', [
        Validators.min(TASA_MINIMA),
        Validators.max(TASA_MAXIMA),
        Validators.pattern(PATRON_VALOR_TASA),
      ]);
    }
  }
  validarPlazos() {
    const plazoI = this.datosLineaIntermediarioForm.get('plazoInicial').value;
    const plazoF = this.datosLineaIntermediarioForm.get('plazoFinal').value;
    if (plazoI && plazoF) {
      this.setearValidadoresLineaInterediarioForm('plazoInicial', [
        Validators.required,
        Validators.max(plazoF),
      ]);
      this.setearValidadoresLineaInterediarioForm('plazoFinal', [
        Validators.required,
        Validators.min(plazoI),
      ]);
    } else {
      this.setearValidadoresLineaInterediarioForm('plazoInicial', [
        Validators.required,
      ]);
      this.setearValidadoresLineaInterediarioForm('plazoFinal', [
        Validators.required,
      ]);
    }
  }
  validarPeriodos() {
    const periodoI =
      this.datosLineaIntermediarioForm.get('periodoInicial').value;
    const periodoF = this.datosLineaIntermediarioForm.get('periodoFinal').value;
    if (periodoI || periodoF) {
      this.setearValidadoresLineaInterediarioForm('periodoInicial', [
        Validators.required,
        Validators.max(periodoF),
      ]);
      this.setearValidadoresLineaInterediarioForm('periodoFinal', [
        Validators.required,
        Validators.min(periodoI),
      ]);
    } else {
      this.setearValidadoresLineaInterediarioForm('periodoInicial', null);
      this.setearValidadoresLineaInterediarioForm('periodoFinal', null);
    }
  }
  guardarDatosLineaIntermediario() {
    const parametrizacionLinea = this.crearObjetoParametrizacionLinea();
    this.isLoading = true;
    this.parametrizacionLineaService
      .saveParametrizacionLinea(parametrizacionLinea)
      .subscribe(
        (data) => {
          this.isCreado = true;
          this.guardarPeriodicidadLinea(data.idParametrizacionLinea);
          this.guardarTasaLinea(data.idParametrizacionLinea);
        },
        (err) => {
          this._sweetAlert.errorModal("Error!",true,err.error.error);
          this.isLoading = false;
        }
      );
  }
  editarDatosLineaIntermediario() {
    const parametrizacionLinea = this.crearObjetoParametrizacionLinea();
    this.isLoading = true;
    this.parametrizacionLineaService
      .updateParametrizacionLinea(parametrizacionLinea)
      .subscribe(
        (data) => {
          this.isCreado = true;
          this._sweetAlert.successModal('Linea modificada exitosamente');
          this.guardarPeriodicidadLinea(data.idParametrizacionLinea);
          this.guardarTasaLinea(data.idParametrizacionLinea);
        },
        (err) => {
          this._sweetAlert.errorModal("Error!",true,err.error.error);
          this.isLoading = false;
        }
      );
  }
  crearObjetoParametrizacionLinea(): NeoParametrizacionLineaDTO {
    const parametrizacionL: NeoParametrizacionLineaDTO = {
      idParametrizacionLinea:
        this.neoParametrizacionEdit.idParametrizacionLinea,
      idCliente_NeoCliente: this.idNeoCliente,
      estado: this.datosLineaIntermediarioForm.get('estadoLinea').value,
      nombre: this.datosLineaIntermediarioForm.get('nombreLinea').value,
      plazoMaximo: this.datosLineaIntermediarioForm.get('plazoFinal').value,
      plazoMinimo: this.datosLineaIntermediarioForm.get('plazoInicial').value,
      periodoGraciaMaximo:
        this.datosLineaIntermediarioForm.get('periodoFinal').value,
      periodoGraciaMinimo:
        this.datosLineaIntermediarioForm.get('periodoInicial').value,
      fechaRegistro: this.neoParametrizacionEdit.fechaRegistro,
      idNombreLineasCredito: +this.datosLineaIntermediarioForm.get('idNombreLineasCredito').value,
    };
    return parametrizacionL;
  }
  guardarPeriodicidadLinea(idParametrizacionLinea: Number) {
    const arregloIdsTipoPeriodicidad =
      this.datosLineaIntermediarioForm.get('periodicidadPagos').value;
    let arregloPeriodicidadLineaDTO: NeoPeriodicidadLineaDTO[] = [];
    arregloIdsTipoPeriodicidad.forEach((idTipoPeriodicidad) => {
      const periodicidadLinea: NeoPeriodicidadLineaDTO = {
        idPeriodicidadLinea: null,
        idParametrizacionLinea_NeoParametrizacionLinea: idParametrizacionLinea,
        idTipoPeriodicidad_NeoTipoPeriodicidad: idTipoPeriodicidad,
      };
      arregloPeriodicidadLineaDTO.push(periodicidadLinea);
    });
    this.periodicidadLineaService
      .savePeriodicidadLinea(arregloPeriodicidadLineaDTO)
      .subscribe(
        (data) => {
          this.isLoading = false;
        },
        (err) => {
          this._sweetAlert.errorModal("Error!",true,err.error.error);
          this.isLoading = false;
        }
      );
  }

  guardarTasaLinea(idParametrizacionLinea: Number) {
    let arregloTasaLineaDTO: NeoTasaLineaDTO[] = [];
    this.tasasDePago.forEach((tasaPago) => {
      const tasaLinea: NeoTasaLineaDTO = {
        idTasaLinea: null,
        tasa: tasaPago,
        idParametrizacionLinea_NeoParametrizacionLinea: idParametrizacionLinea,
      };
      arregloTasaLineaDTO.push(tasaLinea);
    });
    this.tasaLineaService.saveTasaLinea(arregloTasaLineaDTO).subscribe(
      (data) => {
        this.isLoading = false;
        this.router.navigate(['/intermediario/administracion/lineascredito']);
      },
      (err) => {
        this._sweetAlert.errorModal("Error!",true,err.error.error);
        this.isLoading = false;
      }
    );
  }
  crearArrayConNumerosHasta(tope: number) {
    return Array.from({ length: tope }, (v, k) => k + 1);
  }
  agregarTasa() {
    if (this.tasaRepetida() == false) {
      this.tasasDePago.push(
        this.datosLineaIntermediarioForm.get('valorTasa').value
      );
      this._sweetAlert.successModal('Tasa agregada exitosamente');
    } else {
      this._sweetAlert.errorModal("Error!",true,'La tasa ya existe');
    }
  }
  tasaRepetida(): boolean {
    var repetida = false;
    this.tasasDePago.forEach((tasa) => {
      if (tasa == this.datosLineaIntermediarioForm.get('valorTasa').value) {
        repetida = true;
        return repetida;
      }
    });
    return repetida;
  }
  eliminarTasa(posicion: number) {
    this.tasasDePago.splice(posicion, 1);
  }
  cargarDatosParaEditar() {
    if (this.idLineaCredito) {
      this.editar = true;
      this.cargarLineaDeCredito();
      this.cargarTasasDeLineaDeCredito();
      this.cargarPeriodicidadesDeAmortizacion();
    }
  }
  cargarLineaDeCredito() {
    this.parametrizacionLineaService
      .getParametrizacionLineaPorId(this.idLineaCredito)
      .subscribe(
        (data) => {
          this.neoParametrizacionEdit = data;

          this.cargarValorLineaDeCreditoForm();
        },
        (err) => {
        },
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          });
        }
      );
  }
  cargarTasasDeLineaDeCredito() {
    this.tasaLineaService
      .getTasasLineaPorIdParametrizacion(this.idLineaCredito)
      .subscribe((data) => {
        this.neoTasasLineaEdit = data;
        this.setearValidadoresLineaInterediarioForm('valorTasa', null);
        this.cargarValoresTasas();
      });
  }
  cargarPeriodicidadesDeAmortizacion() {
    this.periodicidadLineaService
      .getPeriodicidadesLineaPorIdParametrizacion(this.idLineaCredito)
      .subscribe((data) => {
        this.neoPeriodicidadLineaEdit = data;
        this.cargarValoresPeriodicidad();
      });
  }

  cargarValoresPeriodicidad() {
    let arrayPeriodicidades = [];
    this.neoPeriodicidadLineaEdit.forEach((period) => {
      arrayPeriodicidades.push(period.idTipoPeriodicidad_NeoTipoPeriodicidad);
    });
    this.setearValorDatosLineaIntermediarioForm(
      'periodicidadPagos',
      arrayPeriodicidades
    );
  }

  cargarValoresTasas() {
    this.neoTasasLineaEdit.forEach((tasita) => {
      this.tasasDePago.push(tasita.tasa);
    });
  }

  cargarValorLineaDeCreditoForm() {
    this.setearValorDatosLineaIntermediarioForm(
      'idNombreLineasCredito',
      this.neoParametrizacionEdit.idNombreLineasCredito
    );
    this.setearValorDatosLineaIntermediarioForm(
      'nombreLinea',
      this.neoParametrizacionEdit.nombre
    );
    this.setearValorDatosLineaIntermediarioForm(
      'estadoLinea',
      this.neoParametrizacionEdit.estado
    );
    this.setearValorDatosLineaIntermediarioForm(
      'plazoInicial',
      this.neoParametrizacionEdit.plazoMinimo
    );
    this.setearValorDatosLineaIntermediarioForm(
      'plazoFinal',
      this.neoParametrizacionEdit.plazoMaximo
    );
    this.setearValorDatosLineaIntermediarioForm(
      'periodoInicial',
      this.neoParametrizacionEdit.periodoGraciaMinimo
    );
    this.setearValorDatosLineaIntermediarioForm(
      'periodoFinal',
      this.neoParametrizacionEdit.periodoGraciaMaximo
    );
  }

  setearValorDatosLineaIntermediarioForm(nombreCampo: string, valor: any) {
    this.datosLineaIntermediarioForm.controls[nombreCampo].setValue(valor);
  }
  setearValidadoresLineaInterediarioForm(
    nombreCampo: string,
    validadores: any
  ) {
    this.datosLineaIntermediarioForm.controls[nombreCampo].setValidators(
      validadores
    );
    this.datosLineaIntermediarioForm.controls[
      nombreCampo
    ].updateValueAndValidity();
  }

  validateNumber(event: any) {
    const pattern = /[0-9.]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
